import {
  SET_DISPLAYS,
  SET_DISPLAY_LIST,
  SET_SELECTED_DISPLAY,
  SET_DISPLAY_LIST_FILTER,
} from './actions';
import { merge } from '@its/util';

export default (state = [], action) => {
  switch (action.type) {
    case SET_DISPLAYS:
      return merge(state, { items: action.payload });
    case SET_DISPLAY_LIST:
      return merge(state, { list: action.payload });
    case SET_SELECTED_DISPLAY:
      return merge(state, { detail: action.payload });
    case SET_DISPLAY_LIST_FILTER:
      return merge(state, {
        list: merge(state.list, { currentFilter: action.payload }),
      });
    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/display/reducer.js
 **/